import get from 'get-value';
import {distributionWebsocketCommands} from '../../constants/distributionWebsocketCommands';

export const distributionDealer = (state = {
    isLoadingDealer: false,
    dealers: [],
    correlationId: null,
}, action) => {
    switch (action.type) {
        case distributionWebsocketCommands.DISTRIBUTION_DEALERS_GET: {
            return Object.assign({}, state, {isLoadingDealer: true});
        }
        case distributionWebsocketCommands.DISTRIBUTION_DEALERS_SEND: {
            const dealers = get(action, 'payload.dealers', {default: []});
            return Object.assign({}, state, {
                isLoadingDealer: false,
                dealers,
            });
        }
        case distributionWebsocketCommands.DISTRIBUTION_DEALERS_SEND_ERROR: {
            return Object.assign({}, state, {isLoadingDealer: false});
        }
        default:
            return state;
    }
};
